import { Outlet } from "react-router-dom";
import { useAccount, usePublicClient } from "wagmi";
import { Spinner } from "./Spinner";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { getEthersSigner } from "../../app/wagmi";
import { useState, useEffect } from "react";

/**
 * Component for protecting child routes that require web3 wallet instance.
 * It prompts a user to connect wallet if no web3 instance is found.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Auth() {
  const [signer, setSigner] = useState();
  const {
    address,
    chain,
    isConnected,
    isConnecting,
    connector
  } = useAccount();
  useEffect(() => {
    const init = async () => {
      const s = await getEthersSigner(connector, chain.id);
      setSigner(s);
    };
    if (isConnected && chain && connector !== null && connector !== void 0 && connector.getAccounts) init();
  }, [chain, isConnected, connector]);
  const provider = usePublicClient();
  const data = {
    address,
    chain: {
      id: chain === null || chain === void 0 ? void 0 : chain.id,
      name: chain === null || chain === void 0 ? void 0 : chain.name,
      network: chain
    },
    provider,
    signer
  };
  return !isConnected ? /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx("main", {
      children: isConnecting ? /*#__PURE__*/_jsx(Spinner, {
        text: "Connecting Wallet"
      }) : /*#__PURE__*/_jsx("div", {
        className: "container mx-auto flex flex-row bg-white",
        children: /*#__PURE__*/_jsxs("div", {
          className: "basis-1/2 m-auto",
          children: [/*#__PURE__*/_jsx("h1", {
            className: "mb-6",
            children: "Explorer"
          }), /*#__PURE__*/_jsx(ConnectButton, {})]
        })
      })
    })
  }) : /*#__PURE__*/_jsx(Outlet, {
    context: data
  });
}